<template>
    <div class="daily-analytics-sidebar" v-if="data">
        <div class="daily-panel-card student-card">
            <div class="daily-card-title student">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"/><path d="M22 10v6"/><path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"/></svg>
                <span>Öğrenci</span>
            </div>
            <div class="student-row">
                <img :src="studentAvatar" :alt="data.student?.fullName || 'Öğrenci'" />
                <div class="student-copy">
                    <strong>{{ data.student?.fullName || '-' }}</strong>
                    <span v-if="studentDetail">{{ studentDetail }}</span>
                </div>
            </div>
        </div>

        <div class="daily-panel-card daily-work-card" v-if="data.hasWeek">
            <div class="daily-card-title work">
                <svg viewBox="0 0 20 20" fill="none"><path d="M10 5V10L13.3333 11.6667M18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z" stroke="#FF7B0A" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span>Günlük Çalışılan Süre</span>
            </div>
            <div class="daily-work-summary">
                <strong>{{ appData.fn.getHour(data.workCount) }}</strong>
                <b>%{{ dailyWorkPercent }}</b>
            </div>
            <div class="daily-progress-track"><i :style="{ width: dailyWorkPercent + '%' }"></i></div>
            <div class="daily-goal-row daily-work-goal">
                <span class="daily-goal-label">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <circle cx="12" cy="12" r="9" />
                        <circle cx="12" cy="12" r="5" />
                        <circle cx="12" cy="12" r="1" />
                    </svg>
                    Günlük hedef
                </span>
                <strong class="daily-goal-value">{{ appData.fn.getHour(data.workMaxCount / 7) }} <small>saat</small></strong>
            </div>
            <div v-if="data.isTodayWeek" class="daily-time-control">
                <button type="button" @click="changeDailyWork(-15)">−</button>
                <div><strong>{{ appData.fn.getHour(data.workCount) }}</strong><span>çalışma süresi</span></div>
                <button type="button" @click="changeDailyWork(15)">+</button>
            </div>
            <div v-if="data.isTodayWeek" class="daily-time-shortcuts">
                <button v-for="item in shortcuts" :key="item" type="button" @click="setDailyWork(item * 60)">{{ item }}s</button>
            </div>
        </div>

        <div class="daily-panel-card daily-question-card">
            <div class="daily-card-title question">
                <svg viewBox="0 0 20 20" fill="none"><path d="M13.3333 3.33333H15C15.4419 3.33333 15.8659 3.50893 16.1785 3.82149C16.4911 4.13405 16.6667 4.55797 16.6667 5V6.66667M6.66667 18.3333H5C4.558 18.3333 4.13405 18.1577 3.82149 17.8452C3.50893 17.5326 3.33333 17.1087 3.33333 16.6667V5C3.33333 4.55797 3.50893 4.13405 3.82149 3.82149C4.13405 3.50893 4.558 3.33333 5 3.33333H6.66667M17.7892 13.0525C17.9535 12.8882 18.0839 12.6931 18.1728 12.4784C18.2617 12.2636 18.3075 12.0334 18.3075 11.8008C18.3075 11.5683 18.2617 11.3381 18.1728 11.1233C18.0839 10.9086 17.9535 10.7135 17.7892 10.5492C17.6248 10.3849 17.4297 10.2545 17.215 10.1656C17.0002 10.0767 16.77 10.0309 16.5375 10.0309C16.3049 10.0309 16.0747 10.0767 15.86 10.1656C15.6452 10.2545 15.4501 10.3849 15.2858 10.5492L11.1117 14.725C10.9136 14.9229 10.7686 15.1677 10.69 15.4367L9.9928 17.8271C9.9719 17.8988 9.97064 17.9748 9.98918 18.0472C10.0077 18.1195 10.0454 18.1855 10.0982 18.2384C10.151 18.2912 10.2171 18.3289 10.2894 18.3474C10.3618 18.3659 10.4378 18.3647 10.5095 18.3438L12.8999 17.6465C13.1689 17.568 13.4136 17.423 13.6117 17.225L17.7892 13.0525ZM7.5 1.66667H12.5C12.9602 1.66667 13.3333 2.03976 13.3333 2.5V4.16667C13.3333 4.6269 12.9602 5 12.5 5H7.5C7.03976 5 6.66667 4.6269 6.66667 4.16667V2.5C6.66667 2.03976 7.03976 1.66667Z" stroke="#3478F6" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span>Günlük Çözülen Soru</span>
            </div>
            <div class="daily-question-body">
                <div class="daily-question-donut" :style="dailyQuestionDonutStyle"><div><strong>{{ data.questionCount }}</strong><span>Soru</span></div></div>
                <div class="daily-question-legend">
                    <div><span class="dot green"></span>Doğru <b>{{ questionSummary.correct }}</b></div>
                    <div><span class="dot orange"></span>Yanlış <b>{{ questionSummary.wrong }}</b></div>
                    <div><span class="dot gray"></span>Boş <b>{{ questionSummary.empty }}</b></div>
                </div>
            </div>
            <div class="daily-goal-row daily-question-goal">
                <span class="daily-goal-label">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <circle cx="12" cy="12" r="9" />
                        <circle cx="12" cy="12" r="5" />
                        <circle cx="12" cy="12" r="1" />
                    </svg>
                    Günlük hedef
                </span>
                <strong class="daily-goal-value">{{ (C.Int(data.questionMaxCount) / 7).toFixed(0) }} <small>soru</small></strong>
                <b class="daily-goal-percent">%{{ dailyQuestionPercent }}</b>
            </div>
            <div class="daily-progress-track blue"><i :style="{ width: dailyQuestionPercent + '%' }"></i></div>
        </div>

        <div class="daily-panel-card daily-progress-card">
            <div class="daily-card-title progress-title">
                <svg viewBox="0 0 20 20" fill="none"><path d="m17.5 5.83-6.25 6.25-3.33-3.33-5.42 5.42M17.5 5.83h-5m5 0v5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span>Günlük İlerleme</span>
            </div>
            <div class="daily-target-row"><span>Günlük program ilerlemesi</span><b>%{{ C.Int(data.progress) }}</b></div>
            <div class="daily-progress-track cyan"><i :style="{ width: C.Int(data.progress) + '%' }"></i></div>
        </div>
    </div>
</template>

<script>
import { computed } from "vue";
import { Constants } from "@/helpers/constants";
import { Enums } from "@/helpers/enums";
import { appData, C } from "@/helpers/global";
import avatarStudentBoy from "@/assets/img/avatar-student-boy.png";
import avatarStudentGirl from "@/assets/img/avatar-student-girl.png";
import avatarStudentDefault from "@/assets/img/avatar-student-default.png";

export default {
    name: "AdvisorDailySidebar",
    props: { data: { type: Object, required: true } },
    setup(props) {
        const bus = appData.eventBus([Constants.Key.RightSidebarSelected]);
        const shortcuts = [2, 4, 6, 8, 10];
        const studentAvatar = computed(() => {
            const student = props.data.student || {};
            const gender = C.Str(student.gender || student.genderName || student.genderType || student.sex).toLocaleLowerCase("tr-TR");
            const genderId = C.Int(student.genderId || student.genderTypeId || student.gender || student.sex);
            if (["erkek", "male", "boy"].includes(gender) || genderId === 1) return avatarStudentBoy;
            if (["kadın", "kadin", "female", "girl"].includes(gender) || genderId === 2) return avatarStudentGirl;
            return avatarStudentDefault;
        });
        const findStudentValue = (source, keys, depth = 0) => {
            if (!source || typeof source !== "object" || depth > 4) return "";
            for (const key of keys) {
                const value = source[key];
                if (value !== undefined && value !== null && value !== "") return value;
            }
            for (const value of Object.values(source)) {
                if (value && typeof value === "object") {
                    const found = findStudentValue(value, keys, depth + 1);
                    if (found !== "") return found;
                }
            }
            return "";
        };
        const studentDetail = computed(() => {
            const student = props.data.student || {};
            const rawClass = props.data.studentClassName || findStudentValue(student, ["classRoomName", "classroomName", "className", "gradeName", "schoolClassName", "classLevelName", "classLevel", "classNumber", "gradeLevel", "schoolGrade", "classRoom", "classroom", "grade"]);
            const rawExam = props.data.studentExamTypeName || findStudentValue(student, ["lessonAreaName", "examTypeName", "examName", "examTitle", "lessonArea", "examType"]);
            const classValue = typeof rawClass === "object" ? C.Str(rawClass?.name || rawClass?.title) : C.Str(rawClass);
            const className = /^\d+$/.test(classValue) ? `${classValue}. Sınıf` : classValue;
            const examType = typeof rawExam === "object" ? C.Str(rawExam?.name || rawExam?.title) : C.Str(rawExam);
            return [className, examType].filter(Boolean).join(" · ");
        });
        const dailyWorkPercent = computed(() => {
            const target = C.Int(props.data.workMaxCount) / 7;
            return target > 0
                ? Math.min(100, C.Int((C.Int(props.data.workCount) / target) * 100))
                : 0;
        });
        const dailyQuestionPercent = computed(() => {
            const target = Math.round(C.Int(props.data.questionMaxCount) / 7);
            return target > 0 ? Math.min(100, C.Int((C.Int(props.data.questionCount) / target) * 100)) : 0;
        });
        const questionSummary = computed(() => ({
            correct: C.Int(props.data.questionSummary?.correct),
            wrong: C.Int(props.data.questionSummary?.wrong),
            empty: C.Int(props.data.questionSummary?.empty),
        }));
        const dailyQuestionDonutStyle = computed(() => {
            const { correct, wrong, empty } = questionSummary.value;
            const total = correct + wrong + empty;
            if (!total) return { background: "conic-gradient(#E5EAF1 0 100%)" };
            const correctEnd = (correct / total) * 100;
            const wrongEnd = correctEnd + (wrong / total) * 100;
            return { background: `conic-gradient(#2CC879 0 ${correctEnd}%, #FF970F ${correctEnd}% ${wrongEnd}%, #CFD3DA ${wrongEnd}% 100%)` };
        });
        const setDailyWork = (minute) => {
            props.data.workCount = C.Int(minute);
            bus.set(Constants.Key.RightSidebarSelected, { type: Enums.RIGHT_SELECTED.DAILY_WORK_TIME, data: props.data.workCount });
        };
        const changeDailyWork = (step) => setDailyWork(Math.max(0, Math.min(1200, C.Int(props.data.workCount) + C.Int(step))));
        return { appData, C, shortcuts, studentAvatar, studentDetail, dailyWorkPercent, dailyQuestionPercent, questionSummary, dailyQuestionDonutStyle, setDailyWork, changeDailyWork };
    },
};
</script>

<style scoped>
.daily-analytics-sidebar {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-right: 12px;
}

.daily-panel-card {
    padding: 15px;
    border: 1px solid rgba(70, 45, 105, 0.08);
    border-radius: 24px;
    background: #fff;
    box-shadow: 0 14px 34px rgba(58, 37, 88, 0.07);
}

.daily-card-title {
    display: flex;
    align-items: center;
    gap: 9px;
    color: #24193e;
    font-size: 14px;
    font-weight: 700;
}

.daily-card-title svg {
    width: 16px;
    height: 16px;
    flex: none;
    overflow: visible;
}

.daily-card-title.student svg {
    color: #f2ad24;
    stroke: #f2ad24;
}

.daily-card-title.work svg path {
    stroke: #a34ed8;
}

.daily-card-title.question svg path {
    stroke: #6c74f4;
}

.daily-card-title.progress-title svg {
    color: #59b6e7;
}

.student-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 10px;
}

.student-row img {
    width: 35px;
    height: 35px;
    border-radius: 13px;
    background: #fff8df;
    object-fit: cover;
}

.student-copy {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.student-copy strong {
    overflow: hidden;
    color: #211b35;
    font-size: 14px;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.student-copy span {
    margin-top: 1px;
    color: #7b768b;
    font-size: 11px;
}

.daily-work-summary,
.daily-target-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-top: 17px;
}

.daily-work-summary strong {
    color: #211a3b;
    font-size: 24px;
}

.daily-work-summary b {
    color: #8d3fe0;
    font-size: 12px;
}

.daily-target-row span {
    color: #7b768b;
    font-size: 11px;
}

.daily-target-row b {
    color: #6872ef;
    font-size: 12px;
}

.daily-progress-track {
    height: 7px;
    margin-top: 10px;
    overflow: hidden;
    border-radius: 10px;
    background: #e9edf5;
}

.daily-progress-track i {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: linear-gradient(90deg, #aa5cdb, #883bd8);
}

.daily-progress-track.blue i {
    background: linear-gradient(90deg, #8589fa, #6670ee);
}

.daily-progress-track.cyan i {
    background: linear-gradient(90deg, #79ccef, #50afe1);
}

.daily-goal-row {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    margin-top: 12px;
}

.daily-goal-label {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    min-width: 0;
    color: #777087;
    font-size: 11px;
    white-space: nowrap;
}

.daily-goal-label svg {
    width: 14px;
    height: 14px;
    flex: none;
    color: #8850d9;
}

.daily-goal-value {
    margin-left: auto;
    color: #2c2050;
    font-size: 13px;
    font-weight: 800;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}

.daily-goal-value small {
    color: #716b82;
    font-size: 10px;
    font-weight: 600;
}

.daily-work-goal {
    padding: 9px 10px;
    border: 1px solid #ece3fb;
    border-radius: 11px;
    background: #faf7ff;
}

.daily-question-goal {
    flex-wrap: wrap;
    padding-top: 12px;
    border-top: 1px solid #f0edf6;
}

.daily-goal-percent {
    color: #6872ef;
    font-size: 11px;
    font-weight: 700;
}

.daily-time-control {
    display: grid;
    grid-template-columns: 38px 1fr 38px;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
    padding: 6px;
    border-radius: 14px;
    background: #f8f3fc;
}

.daily-time-control button,
.daily-time-shortcuts button {
    border: 0;
    border-radius: 9px;
    background: #f7f0fc;
    color: #8d3fe0;
    font-weight: 700;
    cursor: pointer;
}

.daily-time-control button {
    height: 36px;
    font-size: 20px;
}

.daily-time-control div {
    text-align: center;
}

.daily-time-control strong,
.daily-time-control span {
    display: block;
}

.daily-time-control strong {
    font-size: 14px;
}

.daily-time-control span {
    color: #93899e;
    font-size: 10px;
}

.daily-time-shortcuts {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 5px;
    margin-top: 9px;
}

.daily-time-shortcuts button {
    padding: 7px 2px;
    font-size: 11px;
}

.daily-question-body {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 18px;
}

.daily-question-donut {
    display: grid;
    place-items: center;
    width: 82px;
    height: 82px;
    flex: 0 0 auto;
    border-radius: 50%;
}

.daily-question-donut > div {
    display: grid;
    place-items: center;
    width: 62px;
    height: 62px;
    border-radius: 50%;
    background: #fff;
}

.daily-question-donut strong,
.daily-question-donut span {
    display: block;
}

.daily-question-donut strong {
    color: #211a3b;
    font-size: 19px;
}

.daily-question-donut span {
    color: #7b768b;
    font-size: 10px;
}

.daily-question-legend {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
}

.daily-question-legend div {
    display: grid;
    grid-template-columns: 10px 1fr auto;
    align-items: center;
    gap: 7px;
    color: #2b2342;
    font-size: 11px;
}

.dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
}

.dot.green {
    background: #52bd7b;
}

.dot.orange {
    background: #f39a32;
}

.dot.gray {
    background: #cfd3da;
}

.daily-progress-card .daily-target-row {
    margin-top: 15px;
}
</style>
